/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Audit_Details_Private_Model_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The configuration of the self-hosted model \"{model}\" was changed." |
*
* @param {Audit_Details_Private_Model_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_private_model_updated_desc = /** @type {((inputs: Audit_Details_Private_Model_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Private_Model_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Konfiguration des selbst gehosteten Modells "${i?.model}" wurde geändert.`)
	return /** @type {LocalizedString} */ (`The configuration of the self-hosted model "${i?.model}" was changed.`)
});